import {
  getNewProducts,
  setData,
} from 'reduxpath/ducks/Product/List'

import {
  getProductById,
  getStandardByProductType,
  getPortfolios,
} from 'reduxpath/ducks/Product/Detail'

import {
  getPortfolioById,
  setSelectedClean,
} from 'reduxpath/ducks/Product/Portfolio'

import {
  getCountries,
  getServices,
  setSelectionsCountry,
  setSelectionsService,
  setSelectedCountry,
  setSelectedService,
} from 'reduxpath/ducks/Reference'

import Home from 'units/ProductBrandNew'
import List from 'units/ProductBrandNew/units/List'
import Detail from 'units/ProductBrandNew/units/Detail'
import Portfolio from 'units/Portfolio'

const list = (store) => {
  const { selectedCountry, selectedService } = store.getState().Reference

  if (selectedCountry) {
    store.dispatch(setSelectedCountry(selectedCountry))
  }
  if (selectedService) {
    store.dispatch(setSelectedService(selectedService))
  }

  const qs = {
    sort: {
      isEligible: 'DESC',
      createdAt: 'DESC',
    },
    limit: 10,
    skip: 0,
    where: {
      isPublished: true,
      isEligible: false,
    },
  }
  if (selectedCountry) {
    qs.where.country = selectedCountry
  }
  if (selectedService) {
    qs.where.service = selectedService
  }

  store.dispatch(
    getNewProducts(qs, (res) => {
      const products = res
      let counter = 0
      products.rows.forEach((product) => {
        const p = product
        store.dispatch(getPortfolios(p.id, {
          sort: 'status ASC',
          limit: 1000000,
          skip: 0,
        }, (portfolios) => {
          counter += 1
          p.portfolios = portfolios
          if (counter === products.rows.length) {
            store.dispatch(setData(products))
          }
        }))
      })
    }),
  )

  store.dispatch(
    getCountries((countries) => {
      store.dispatch(setSelectionsCountry(countries.rows))
    }),
  )

  store.dispatch(
    getServices((services) => {
      store.dispatch(setSelectionsService(services.rows))
    }),
  )
}

const detail = (store, id) => {
  store.dispatch(getProductById(id, (product) => {
    const productType = product.productType.id
    store.dispatch(
      getPortfolios(product.id),
    )
    store.dispatch(
      getStandardByProductType(productType, {
        sort: 'sequence DESC',
        limit: 10,
        skip: 0,
      }),
    )
  }))
}

const portfolio = (store, portfolioId, productId) => {
  store.dispatch(setSelectedClean())
  store.dispatch(getPortfolioById(portfolioId))
  store.dispatch(getProductById(productId))
}


export default {
  populate: {
    list,
    detail,
    portfolio,
  },
  components: {
    Home,
    List,
    Detail,
    Portfolio,
  },
}
